import { gql, useMutation } from '@apollo/client';
import {
  Payments_RecordCashPaymentMutation,
  Payments_RecordCashPaymentMutationVariables,
} from '@/types';

const RECORD_CASH_PAYMENT_RESPONSE_FRAGMENT = gql`
  fragment RecordCashPaymentResponseFields on RecordCashPaymentResponse {
    alert_level
    alert_message
    payment_batch_id
  }
`;

export const RECORD_CASH_PAYMENT_MUTATION = gql`
  mutation Payments_RecordCashPayment(
    $creditMemos: [PartialPaymentCreditMemoInput!]
    $creditRequestBatchLineItems: [CreditRequestBatchLineItemInput!]
    $invoices: [PartialPaymentInvoiceInput!]!
    $memo: String
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    recordCashPayment(
      credit_memos: $creditMemos
      credit_request_batch_line_items: $creditRequestBatchLineItems
      invoices: $invoices
      memo: $memo
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...RecordCashPaymentResponseFields
    }
  }
  ${RECORD_CASH_PAYMENT_RESPONSE_FRAGMENT}
`;

export const useRecordCashPayment = () => {
  return useMutation<
    Payments_RecordCashPaymentMutation,
    Payments_RecordCashPaymentMutationVariables
  >(RECORD_CASH_PAYMENT_MUTATION);
};
